(ns practitest.frontend.integration-settings.jira-entity-mapping.subs
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-sub
 ::entity-mapping
 (fn [db _]
   (:entity-mapping db)))

(re-frame/reg-sub
 ::loading?
 :<- [::entity-mapping]
 (fn [entity-mapping _]
   (:loading? entity-mapping)))

(re-frame/reg-sub
 ::data
 :<- [::entity-mapping]
 (fn [entity-mapping _]
   (:data entity-mapping)))

(re-frame/reg-sub
 ::issues-sync-enabled?
 :<- [::data]
 (fn [data _]
   (:issues_sync_enabled data false)))

(re-frame/reg-sub
 ::requirements-sync-enabled?
 :<- [::data]
 (fn [data _]
   (:requirements_sync_enabled data false)))

(re-frame/reg-sub
 ::selected-project-ids
 :<- [::entity-mapping]
 (fn [entity-mapping _]
   (:selected-project-ids entity-mapping #{})))

(re-frame/reg-sub
 ::available-projects
 :<- [::entity-mapping]
 (fn [entity-mapping _]
   (:available-projects entity-mapping [])))

(re-frame/reg-sub
 ::projects-loading?
 :<- [::entity-mapping]
 (fn [entity-mapping _]
   (:projects-loading? entity-mapping false)))

(re-frame/reg-sub
 ::project-issue-types
 :<- [::entity-mapping]
 (fn [entity-mapping _]
   (:project-issue-types entity-mapping {})))

(re-frame/reg-sub
 ::project-types-loading-set
 :<- [::entity-mapping]
 (fn [entity-mapping _]
   (:project-types-loading entity-mapping #{})))

(re-frame/reg-sub
 ::project-types-loading?
 :<- [::project-types-loading-set]
 (fn [loading-set [_ jira-project-id]]
   (contains? loading-set jira-project-id)))

(re-frame/reg-sub
 ::saving?
 :<- [::entity-mapping]
 (fn [entity-mapping _]
   (:saving? entity-mapping false)))

(re-frame/reg-sub
 ::dirty?
 :<- [::entity-mapping]
 (fn [entity-mapping _]
   (let [data (:data entity-mapping)
         saved-data (:saved-data entity-mapping)]
     (and (some? saved-data)
          (not= data saved-data)))))

(re-frame/reg-sub
 ::milestones-sync-enabled?
 :<- [::data]
 (fn [data _]
   (:milestones_sync_enabled data false)))

(re-frame/reg-sub
 ::milestones-plan-supported?
 :<- [::data]
 (fn [data _]
   (:milestones_plan_supported data false)))

(re-frame/reg-sub
 ::milestones-selected-project-ids
 :<- [::data]
 (fn [data _]
   (set (map keyword (:milestones_selected_project_ids data [])))))

(re-frame/reg-sub
 ::import-completed-sprints?
 :<- [::data]
 (fn [data _]
   (:import_completed_sprints data false)))

(re-frame/reg-sub
 ::jira-user-login-url
 :<- [::entity-mapping]
 (fn [entity-mapping _]
   (:jira-user-login-url entity-mapping)))

(re-frame/reg-sub
 ::sub-tabs-props
 :<- [::entity-mapping]
 (fn [entity-mapping _]
   {:active            (:active-tab entity-mapping)
    :tabs              (:tabs entity-mapping [])
    :bugtracker-label  (:bugtracker-label entity-mapping)
    :identifier        (:identifier entity-mapping)}))
